/* unplugin-vue-components disabled */import { render } from "./feed.vue?vue&type=template&id=12409325&scoped=true"
import script from "./feed.vue?vue&type=script&lang=js"
export * from "./feed.vue?vue&type=script&lang=js"

import "./feed.vue?vue&type=style&index=0&id=12409325&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12409325"],['__file',"src/pages/pulse/feed/feed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12409325"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12409325', __exports__)) {
    api.reload('12409325', __exports__)
  }
  
  module.hot.accept("./feed.vue?vue&type=template&id=12409325&scoped=true", () => {
    api.rerender('12409325', render)
  })

}


export default __exports__